import { PixelRatio } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Box from '@/components/UI/Box';
import { graphql, type ResultOf } from '@/gql/graphql';
import ChatMediaUploadedItem from './ChatMediaUploadedItem';

const IMAGES_PER_ROW = 2;
const IMAGE_SIZE = 100;
const ALBUM_GAP = 2;
const ALBUM_WIDTH = IMAGES_PER_ROW * IMAGE_SIZE + ALBUM_GAP;

const ChatMediaCarouselFragment = graphql(/* GraphQL */ `
  fragment ChatMediaCarousel on message_media {
    id
    media_id
    created_by
  }
`);
function ChatMediaCarousel({
  media,
}: {
  media: ResultOf<typeof ChatMediaCarouselFragment>[];
}) {
  const rows = media.reduce<ResultOf<typeof ChatMediaCarouselFragment>[][]>(
    (albumRows, item, itemIndex) => {
      if (itemIndex % IMAGES_PER_ROW === 0) {
        albumRows.push([item]);
      } else {
        albumRows[albumRows.length - 1]?.push(item);
      }

      return albumRows;
    },
    [],
  );

  return (
    <Box mt="sm" style={style.container}>
      {rows.map((row) => {
        const albumItemWidth = row.length === 1 ? ALBUM_WIDTH : IMAGE_SIZE;

        return (
          <Box key={row[0]?.id} direction="horizontal" style={style.row}>
            {row.map((item) => (
              <ChatMediaUploadedItem
                isAlbum
                key={item.id}
                id={item.id}
                mediaId={item.media_id}
                variant={Math.max(Math.floor(PixelRatio.get()), 3) * IMAGE_SIZE}
                createdBy={item.created_by}
                albumWidth={albumItemWidth}
              />
            ))}
          </Box>
        );
      })}
    </Box>
  );
}
const style = StyleSheet.create({
  container: {
    alignSelf: 'flex-start',
    borderRadius: 16,
    gap: ALBUM_GAP,
    overflow: 'hidden',
  },
  row: {
    gap: ALBUM_GAP,
  },
});
export default ChatMediaCarousel;
